import React from "react"
import classNames from "classnames"
import styles from "./styles.module.scss"

const Input = ({
  type = "text",
  id = undefined,
  name = undefined,
  minValue = undefined,
  maxValue = undefined,
  stepValue = undefined,
  placeholder = undefined,
  placeholderIcon,
  disabled = false,
  readOnly = false,
  value,
  error,
  onChange = () => {},
  onInput = () => {},
  onKeyPress = () => {},
  onKeyUp = () => {},
  onClick = () => {},
  onPaste = () => {},
  style = {},
  options = {},
}) => {
  const props = {
    className: classNames(styles.input, {
      [styles.error]: !!error,
    }),
    id: id || name,
    name: name,
    type: type,
    min: minValue,
    max: maxValue,
    step: stepValue,
    onChange: onChange,
    onInput: onInput,
    onKeyPress: onKeyPress,
    onKeyUp: onKeyUp,
    onClick: onClick,
    onPaste: onPaste,
    placeholder: placeholder,
    disabled: disabled,
    readOnly: readOnly,
    style: style,
    value: value || "",
    ...options,
  }

  return placeholderIcon ? (
    <div className={styles["input-wrapper"]}>
      <span className={styles["placeholder-icon"]}>{placeholderIcon}</span>
      <input {...props} />
      {error ? <p className={styles["error-message"]}>{error}</p> : null}
    </div>
  ) : (
    <React.Fragment>
      <input {...props} />
      {error ? <p className={styles["error-message"]}>{error}</p> : null}
    </React.Fragment>
  )
}

export default Input
